// src/hooks/hotelRatings/useGetHotelRating.js
import { useQuery } from "@tanstack/react-query";
import { getHotelRating } from "../../api/apiHotelRatings";

const QUERY_KEY = ["hotelRating"];

const useGetHotelRating = (id) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [...QUERY_KEY, id],
    queryFn: () => getHotelRating(id),
    enabled: !!id,
  });

  return {
    isLoading,
    error: isError ? error : null,
    hotelRating: data?.data || null,
  };
};

export default useGetHotelRating;
